import { inject, provide, ref } from 'vue';

import type { InjectionKey, Ref } from 'vue';

export interface IHoverContextProps {
  startRow: Ref<number>;
  endRow: Ref<number>;
  onHover: (start?: number, end?: number) => void;
}

export const HoverContextKey: InjectionKey<IHoverContextProps> = Symbol('cds:table:hover');

export const useProvideHover = (props: IHoverContextProps) => {
  provide(HoverContextKey, props);
};

export const useInjectHover = () =>
  inject(HoverContextKey, { startRow: ref(-1), endRow: ref(-1), onHover() {} } as IHoverContextProps);
